import type { PayableRow } from "../../../shared/account-finance/payables-domain";
import type { FinanceDirection } from "../../../shared/account-finance/payables-domain";

export function payablePayments(row: PayableRow, date: string, direction: FinanceDirection = "payables") {
  if (!row.account || !row.entries || !row.observedAt) return null;
  const amount = (entry: NonNullable<PayableRow["entries"]>[number]) => direction === "payables"
    ? BigInt(entry.debit) - BigInt(entry.credit) : BigInt(entry.credit) - BigInt(entry.debit);
  const payments = row.entries.filter(entry => entry.documentType === (direction === "payables" ? 35 : 34) && !entry.isReturn
    && entry.date <= date && amount(entry) > 0n)
    .map(entry => ({ id: entry.id, document: entry.document, date: entry.date,
      amount: String(amount(entry)) }))
    .sort((a, b) => b.date.localeCompare(a.date) || a.document.localeCompare(b.document));
  return { total: String(payments.reduce((sum, payment) => sum + BigInt(payment.amount), 0n)), payments };
}

export function payableCheques(row: PayableRow, date: string, direction: FinanceDirection = "payables") {
  if (!row.account || !row.entries || !row.observedAt) return null;
  const cheques = row.entries.filter(entry => entry.documentType === (direction === "payables" ? 67 : 4)
    && !entry.isReturn && entry.date <= date)
    .map(entry => ({ id: entry.id, document: entry.document, date: entry.date, dueDate: entry.dueDate,
      amount: String(direction === "payables" ? BigInt(entry.debit) - BigInt(entry.credit) : BigInt(entry.credit) - BigInt(entry.debit)) }))
    .filter(entry => BigInt(entry.amount) > 0n)
    .sort((a, b) => (a.dueDate ?? "9999").localeCompare(b.dueDate ?? "9999") || a.id.localeCompare(b.id));
  return { total: String(cheques.reduce((sum, cheque) => sum + BigInt(cheque.amount), 0n)), cheques };
}
